<template>
  <VModal ref="modal" @modal:hidden="$emit('close')" disable-backdrop-click>
    <BaseVeeForm :action="destroy" v-slot="formProps" class="mx-auto max-w-lg">
      <BaseCard @click.stop>
        <BaseCardHeader> Delete funnel </BaseCardHeader>
        <BaseCardBody>
          <p class="text-gray-600 mb-4">
            Are you sure you want to delete this funnel stage? Once a funnel stage is deleted, all
            related audiences will be detached.
          </p>
        </BaseCardBody>
        <BaseCardFooter gray>
          <div class="flex space-x-2">
            <BaseButton
              primary
              :disabled="formProps.isPending || formProps.isRejected || formProps.invalid"
            >
              Delete
            </BaseButton>
            <BaseButton
              type="button"
              ghost
              :disabled="formProps.isPending"
              @click="$refs.modal.close()"
            >
              Cancel
            </BaseButton>
          </div>
        </BaseCardFooter>
      </BaseCard>
    </BaseVeeForm>
  </VModal>
</template>

<script>
const props = {
  action: {
    type: Function,
    required: true,
  },
};

const methods = {
  async destroy() {
    try {
      await this.action();

      this.$refs.modal.close();

      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

export default {
  name: 'FunnelStageDeleteModal',
  props,
  methods,
};
</script>
